import * as i18next from 'i18next';

import { CellRenderer, MainColumns } from '../../../components/TableGrid';
import { User } from '../../../contexts/AuthContext/authContext.types';
import { QueryTypeEnum, SearchReportTypes } from '../../../core/api/search';
import { QueryDto } from '../../../generated/model/queryDto';

export const getQueryListTableColumns = (
  t: i18next.TFunction,
  onCellClicked: (data: QueryDto) => void,
  user: User | undefined,
  adminView: boolean,
) => {
  return [
    {
      headerName: `${t('queryList:columns:name')}`,
      field: 'name',
      cellRenderer: CellRenderer.Clickable,
      cellRendererParams: {
        onClickHandler: onCellClicked,
      },
      // https://www.ag-grid.com/javascript-grid-filter-text/
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: `${t('queryList:columns:comments')}`,
      field: 'comments',
      // https://www.ag-grid.com/javascript-grid-filter-text/
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      filterParams: { suppressAndOrCondition: true },
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
    {
      headerName: `${t('queryList:columns:type')}`,
      field: 'type',
      // https://www.ag-grid.com/javascript-grid-filter-text/
      floatingFilter: true,
      filter: 'agSetColumnFilter',
      valueFormatter: queryTypeFormatter,
      filterParams: {
        suppressAndOrCondition: true,
        suppressSelectAll: true,
        suppressMiniFilter: true,
        defaultToNothingSelected: true,
        values: [QueryTypeEnum.COMPANY_SEARCH, QueryTypeEnum.FILTER_CONFIGURATION],
        valueFormatter: queryTypeFormatter,
      },
    },
    {
      headerName: `${t('queryList:columns:creationTime')}`,
      field: 'createdAt',
      cellRenderer: CellRenderer.Date,
      // https://www.ag-grid.com/javascript-grid-filter-date/
      // floatingFilter: true,
      // filter: 'agDateColumnFilter',
      // filterParams: { suppressAndOrCondition: true, browserDatePicker: false },
      // floatingFilterComponentParams: { suppressFilterButton: true },
    },
    ...(user?.isAdminUser && adminView
      ? [
          {
            headerName: `${t('queryList:columns:createdBy')}`,
            field: 'username',
            // https://www.ag-grid.com/javascript-grid-filter-text/
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: { suppressAndOrCondition: true, filterOptions: ['equals'] },
            floatingFilterComponentParams: { suppressFilterButton: true },
          },
          {
            headerName: `${t('queryList:columns:companyId')}`,
            field: 'companyId',
            // https://www.ag-grid.com/javascript-grid-filter-text/
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: { suppressAndOrCondition: true, filterOptions: ['equals'] },
            floatingFilterComponentParams: { suppressFilterButton: true },
          },
        ]
      : [
          {
            headerName: `${t('queryList:columns:createdBy')}`,
            field: 'username',
            // https://www.ag-grid.com/javascript-grid-filter-text/
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: { suppressAndOrCondition: true },
            floatingFilterComponentParams: { suppressFilterButton: true },
          },
        ]),
    {
      headerName: `${t('queryList:columns:ccy')}`,
      field: 'ccy',
    },
    {
      headerName: `${t('queryList:columns:results')}`,
      field: 'numberOfCompaniesLimited',
      cellRenderer: CellRenderer.Number,
    },
    {
      headerName: `${t('queryList:columns:itemsCount')}`,
      field: 'numberOfCompaniesExported',
      cellRenderer: CellRenderer.Number,
    },
    {
      headerName: `${t('queryList:columns:listViewReport')}`,
      field: 'rowData',
      cellRenderer: CellRenderer.ReportDownload,
      cellRendererParams: {
        reportType: SearchReportTypes.RAW,
      },
    },
    {
      headerName: `${t('queryList:columns:structuredViewReport')}`,
      field: 'marketingReport',
      cellRenderer: CellRenderer.ReportDownload,
      cellRendererParams: {
        reportType: SearchReportTypes.MARKETING,
      },
    },
  ] as MainColumns[];
};

function queryTypeFormatter(params: any) {
  switch (params.value) {
    case QueryTypeEnum.COMPANY_SEARCH: {
      return 'Company search';
    }
    case QueryTypeEnum.FILTER_CONFIGURATION: {
      return 'Filter configuration';
    }
  }
  return params.value;
}
